/**
 * Normalizes the role string to handle different formats and special cases
 * @param {string} role - The role to normalize
 * @param {string} [email] - Optional email for special cases (like admin email)
 * @returns {string} Normalized role
 */
export function normalizeRole(role, email) {
  if (!role) return '';
  
  // Convert to string, handle null/undefined, then lowercase and trim
  const roleStr = role === null || role === undefined ? '' : String(role);
  const normalized = roleStr.toLowerCase().trim();
  
  // Handle special cases (like admin email)
  if (email === 'asdfloteam@gmail.com') {
    return 'admin';
  }
  
  // Map common variations to standard roles
  const roleMap = {
    'admin': 'admin',
    'administrator': 'admin',
    'superadmin': 'admin',
    'super_admin': 'admin',
    'parent': 'parent',
    'guardian': 'parent',
    'caregiver': 'parent',
    'professional': 'professional',
    'therapist': 'professional',
    'provider': 'professional',
    'organization': 'organization',
    'org': 'organization',
    'center': 'organization',
    'school': 'organization',
    'cdc': 'organization',
  };
  
  return roleMap[normalized] || normalized;
}

/**
 * Checks if a user has admin privileges
 * @param {string} role - The user's role
 * @param {string} [email] - Optional email for admin check
 * @returns {boolean} True if the user is an admin
 */
export function isAdmin(role, email) {
  return normalizeRole(role, email) === 'admin';
}
